import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, AfterContentInit, Input, EventEmitter, Output } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertType } from 'base-models';
import { MessageError } from 'base-models';
import { SortHelper } from 'shtools';
import { Site } from 'solar-bo';
import { FrLayer, FrCoordinate } from 'gmap';
import { mapcte } from 'gmap';

import { OlObjectTypeEnum } from 'solar-bo';;
import { IssueImageComponent } from '../../supervis/issueimage/issueimage.component';
import { MapOnMoveHelper } from 'gmap';
import { MapTooltipHelper } from 'gmap';
import { DashboardService } from '../../services/dashboard.service';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { IDB_filter, IDB_Chart_Res, DB_filter, DBColumnsEnum } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';

import { MapMarkerHelper } from 'gmap';
import { MapSupervisionHelper, MapIssueOverlay, MapSiteHelper, MapSupervisionIssues, MapSiteOverlay } from '@solar/ol';
import { DbFilter } from '@solar/solar/dashboard/db-overview/db-filter-helper';
import { MapSiteCluster } from '@solar/ol/map-site-cluster';

import * as ol from 'ol';
import { transform as ol_transform } from 'ol/proj';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import { Cluster, OSM, Vector as VectorSource } from 'ol/source';
import { createEmpty, extend, getHeight, getWidth } from 'ol/extent';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';
import * as olInteraction from 'ol/interaction';

import { OlMainComponent, OlMapBaseComponent, OlMapOptions } from 'gmap';
import { TooltipSite } from '@solar/ol/tooltip-site.model';


//providers:[DashboardService]
@Component({
  selector: 'app-site-list-map',
  templateUrl: './site-list-map.component.html',
  styleUrls: ['./site-list-map.component.scss']
})
export class SiteListMapComponent extends SolarBase1Component implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {


  @ViewChild('map_db') mapc: OlMainComponent;

  
  private _siteList: Site[] = [];
  @Input() 
  public get siteList(): Site[] {
    return this._siteList;
  }
  public set siteList(value: Site[]) {
    this._siteList = value;
    this.drawSitesClusterOnMap(this._siteList);
  }

  @Input() autoLoad:boolean=true;
  @Output() siteClickedEvent:EventEmitter<Site>=new EventEmitter();

  public dbFilter: DbFilter = new DbFilter();
  /**
   * layer object with issues
   */
  layer_Issues: any[] = [];
  mapSupervisionIssues: MapSupervisionIssues;
  mapSiteHelper: MapSiteHelper;

  constructor(
    private dashService: DashboardService
  ) {
    super();
    this.mapSiteHelper = new MapSiteHelper();
  }

  ngOnInit() {

  }

  mapcontrol: boolean = true;
  issueOverlay: MapIssueOverlay;
  tooltipOverlay: MapSiteOverlay;
  mapOnMoveHelper: MapOnMoveHelper;
  mapSiteCluster: MapSiteCluster;
  mapSiteTooltip:TooltipSite;

  ngAfterViewInit() {
    if (this.mapc) {
      this.mapcontrol = true;
      this.mapc.setZoom(2);
      this.mapc.onFeatureClick.subscribe(res => this.onFeatureClick(res));
      this.mapOnMoveHelper = new MapOnMoveHelper(this.mapc);
      this.mapSiteCluster = new MapSiteCluster(this.mapc, this.mapSiteHelper);

      this.issueOverlay = new MapIssueOverlay(this.mapc);
      this.mapOnMoveHelper.addListener(this.issueOverlay);
      //this.tooltipOverlay = new MapSiteOverlay(this.mapc);
      //this.tooltipOverlay.addLayer('sitesmarkers'); 
      //this.mapOnMoveHelper.addListener(this.tooltipOverlay);
      
      this.mapSiteTooltip=new TooltipSite(this.mapc);
    }

    this.getSiteList()
 }

  ngAfterContentInit() {

  }

  ngOnDestroy() {
    this.mapcontrol = false;
  }

  onFeatureClick(featuresAs: { feature: Feature, layer: VectorLayer }[]) {
    console.log(featuresAs);
    if (!featuresAs) {
      return;
    }

    let features: any = [];
    for (let item of featuresAs) {
      let featuresList = item.feature.get('features');
      if (featuresList != undefined) {
        features.push(...featuresList);
        if (features.length>1){
          //es un cluster
          let extent = createEmpty();
          let map = this.mapc.map;
          featuresList.forEach(function (f, index, array) {
            extend(extent, f.getGeometry().getExtent());
          });

          map.getView().fit(extent, {size:map.getSize(),padding: [50,50,50,50] });
          return;          
        }
        else{
          //es un cluster pero con un solo item, el site asi que lo sacamos
          
        }
      } else {
        features.push(item.feature);
      }
    }


    for (let featInfo of features) {
      let feat=featInfo;
      let layerInfo: FrLayer = feat.frlayerinfo;
      if (layerInfo) {
        if (layerInfo.ref == OlObjectTypeEnum.issue) {
          let issue = layerInfo.refObject;
          if (issue) {
            IssueImageComponent.openModal(this.dialog, issue, issue.supervision);
            return;
          }
        }
        else if (layerInfo.ref == OlObjectTypeEnum.site) {
          let site = layerInfo.refObject;
          if (site) {
            console.log("Feature clicked is site:", site);
            this.siteClickedEvent.emit(site);
            return;
          }
        }

      }
    }
  }



  getSiteList(): void {
    if (this.autoLoad==false){
      return;
    }
    this.listerrmessage = "";
    this.loading = true;
    this.dashService.getSiteList()
      .subscribe(
        reslist => this.getSiteListhandleresult(reslist)
        , err => this.getSiteListhandleError(err)
      );
  }

  getSiteListhandleresult(newlist: any[]) {
    this.listerrmessage = '';
    this.loading = false;
    newlist = SortHelper.sortMultiple(newlist, ["name"]);
    this.siteList = newlist;
    this.dbFilter.filterAdd(DBColumnsEnum.site_id, newlist);

    this.drawSitesClusterOnMap(this.siteList);

    let elemSelected: IDB_filter[] = [];

    if (newlist.length > 0) {
      let sites = new DB_filter(DBColumnsEnum.site_id, null);
      sites.value = newlist;
      elemSelected.push(sites);
    }
  }

  getSiteListhandleError<T>(err: any) {
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  drawSitesClusterOnMap(sitesSelected: Site[], force?: boolean) {
    try {
      if (!this.mapSiteCluster){
        return;
      }

      this.mapSiteCluster.drawSitesClusterOnMap(sitesSelected);

      return;
    } catch (ex) {
      console.log(ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }

  }

  drawSitesOnMap(sitesSelected: Site[], force?: boolean) {
    if (!this.mapc ) {
      return;
    }
    try {
      if (!sitesSelected || sitesSelected.length == 0) {
        return;
      }

      let frlayerinfo = new FrLayer('Sites', 'sitesmarkers');
      let layer = this.mapc.layerGetByFrid(frlayerinfo.id);
      if (layer) {
        this.mapc.layerRemove(frlayerinfo.id);
      }
      layer = this.mapc.layerCreateVectorLayer(frlayerinfo);

      let mapSitesHelper = new MapSiteHelper();
      for (let item of sitesSelected) {
        let site: Site = item;
        if (site.info.location != null) {
          const feature = MapMarkerHelper.markerCreate(null, site.info.location[0], site.info.location[1], site.id, site.name);
          let layerExt = feature[mapcte.frlayerinfo_FieldName];
          layerExt.ref = OlObjectTypeEnum.site;
          layerExt.refObject = site;
          layer.getSource().addFeature(feature);
        }
      }
      layer.setStyle(this.mapSiteHelper.siteMapStyleFull.bind(this.mapSiteHelper));

      this.mapc.layerAdd(layer);
      if (sitesSelected.length == 1) {
        let site: Site = sitesSelected[0];
        if (site.info.location) {
          this.mapc.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1]));
          this.mapc.zoomUpgrade(17);
        }
      }
      else if (sitesSelected.length > 1) {
        this.mapc.setZoomToExtent(layer);

      }
      else {
        this.mapc.setZoom(4);
      }

    } catch (ex) {
      console.log(ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }

  }
}
